import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router'

const ProtectedRoute = ({element, nopromo, routeUrl}) => {

  const user = JSON.parse(localStorage.getItem("user_obj"));
  const baseRoute = nopromo && routeUrl ? routeUrl : `/${localStorage.getItem('channel') === 'alopexia-ads' ? 'c1' : 'start-test'}`
  console.log("propssss", nopromo, routeUrl);
  

  return (
    user ? element : <Navigate to={baseRoute} replace/>
  )
}

export default ProtectedRoute